import React from 'react'
import { useApp } from '../../AppContext/AppProvider'
import {
  checkCreditCardStatus,
  getCreditCardDetails,
  isErrored,
  isReady,
  mapCreditCardError
} from '../../../services/creditCard.service'
import { useIntervalPromise } from '../../../hooks/Poller.hook'
import { CreditCardErrors, CreditCardSubmittedProps } from './types'
import { ApplicationWaitingComponent as CreditCardWaiting } from '../ApplicationSubmitted/ApplicationWaiting.component'
import { extractMessageFromServiceError } from '../../../services/error.service'

export const CreditCardSubmitted: React.FC<CreditCardSubmittedProps> = ({
  cardId,
  handleReady,
  handleError
}) => {
  const { application } = useApp()
  const checkCreditStatus = checkCreditCardStatus(application)
  const fetchCardDetails = getCreditCardDetails(application)

  useIntervalPromise(async () => {
    try {
      const creditCardResponse = await checkCreditStatus(cardId)
      if (isReady(creditCardResponse.status)) {
        const creditDetails = await fetchCardDetails(cardId)
        handleReady(creditDetails)
      } else if (isErrored(creditCardResponse.status)) {
        handleError(mapCreditCardError(creditCardResponse.status))
      }
    } catch (err) {
      handleError({
        type: CreditCardErrors.HTTP,
        errorMessage: extractMessageFromServiceError(err)
      })
    }
  }, 2000)

  return (
    <CreditCardWaiting subtitleText="Your Credit Acceptance Offer is processing" />
  )
}
